import { ref } from 'vue';
import api from '@/utils/api';

export function useExport() {
  const showExportDropdown = ref(false);
  const exporting = ref(false);
  const exportError = ref(null);

  const exportFormats = [
    {
      value: 'pdf',
      label: 'PDF',
      icon: '📄',
      description: 'Portable Document Format'
    },
    {
      value: 'txt',
      label: 'TXT (Standard)',
      icon: '📝',
      description: 'Plain text format'
    },
    {
      value: 'nap-sales',
      label: 'NAP Sales (TXT)',
      icon: '📊',
      description: 'Bulgarian VAT reporting - Sales'
    },
    {
      value: 'nap-purchases',
      label: 'NAP Purchases (TXT)',
      icon: '📊',
      description: 'Bulgarian VAT reporting - Purchases'
    },
    {
      value: 'html',
      label: 'HTML',
      icon: '🌐',
      description: 'Web page format'
    }
  ];

  const exportSingle = async (invoiceId, format) => {
    try {
      exporting.value = true;
      exportError.value = null;

      let url = '';
      
      switch (format) {
        case 'pdf':
          url = `/api/invoices/${invoiceId}/download/pdf`;
          break;
        case 'txt':
          url = `/api/invoices/${invoiceId}/download/txt`;
          break;
        case 'nap-sales':
          url = `/api/invoices/${invoiceId}/download/txt?format=nap-sales`;
          break;
        case 'nap-purchases':
          url = `/api/invoices/${invoiceId}/download/txt?format=nap-purchases`;
          break;
        case 'html':
          url = `/api/invoices/${invoiceId}/download/html`;
          break;
        default:
          throw new Error('Invalid export format');
      }

      // Create a temporary link to trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      showExportDropdown.value = false;
    } catch (error) {
      console.error('Export failed:', error);
      exportError.value = error.response?.data?.message || 'Export failed. Please try again.';
    } finally {
      exporting.value = false;
    }
  };

  const toggleExportDropdown = () => {
    showExportDropdown.value = !showExportDropdown.value;
  };

  const closeExportDropdown = () => {
    showExportDropdown.value = false;
  };

  return {
    showExportDropdown,
    exporting,
    exportError,
    exportFormats,
    exportSingle,
    toggleExportDropdown,
    closeExportDropdown
  };
}
